<template>
    <div id="notifications">
        <div class="content-wrapper">
            <div class="page-content fade-in-up">
                <div class="row">
                    <div class="col-md-12">
                        <div class="ibox">
                            <div class="ibox-body">
                                <ul class="nav nav-tabs tabs-line">
                                    <li class="nav-item">
                                        <a @click="getNotifications('False')" id="newTasks" class="nav-link active"
                                           href="#tab-1" data-toggle="tab">{{$t('message.new')}}</a>
                                    </li>
                                    <li class="nav-item">
                                        <a @click="getNotifications('True')" class="nav-link" href="#tab-2"
                                           data-toggle="tab">{{$t('message.done')}}</a>
                                    </li>
                                </ul>
                                <div class="tab-content">
                                    <div id="tab-1" class="tab-pane fade active show">
                                        <div class="row">
                                            <div class="col-md-1"></div>
                                            <div class="col-md-10">
                                                <div class="row text-center">
                                                    <div style="width: 100%" v-if="!tasks.length">
                                                        <h6>{{$t('message.noNewTasks')}}</h6>
                                                    </div>
                                                    <table class="table table-striped">
                                                        <tbody v-if="tasks.length">
                                                        <tr v-for="(task, index) in tasks" :key="index">
                                                            <td>{{task.id}}</td>
                                                            <td>{{$moment(task.created).format(formatString)}}</td>
                                                            <td class="tasks-td" style="white-space: pre; text-align:left">
                                                                {{task.text}}
                                                            </td>
                                                            <td class="tasks-td">
                                                                <approve-budget-task @taskUpdated="handleTaskUpdated"
                                                                                     :newTab="newTab"
                                                                                     :task-id="task.id"
                                                                                     :additional-data="JSON.parse(task.additional_data)"
                                                                                     v-if="task.name === 'approve_additional_budget'"></approve-budget-task>
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="tab-2" class="tab-pane fade active">
                                        <div class="row">
                                            <div class="col-md-1"></div>
                                            <div class="col-md-10">
                                                <div class="row text-center">
                                                    <div style="width: 100%" v-if="!done_tasks.length">
                                                        <h6>{{$t('message.noDoneTasks')}}</h6>
                                                    </div>
                                                    <table v-if="done_tasks.length" class="table table-striped">
                                                        <tbody>
                                                        <tr v-for="(task, index) in done_tasks" :key="index">
                                                            
                                                            <td>{{$moment(task.created).format(formatString)}}</td>
                                                            <td class="tasks-td" style="white-space: pre-line;">
                                                                {{task.text}}
                                                            </td>
                                                            <td class="tasks-td">
                                                                <approve-budget-task
                                                                        @taskUpdated="handleTaskUpdated"     
                                                                        :task-id="task.id"
                                                                        :additional-data="JSON.parse(task.additional_data)"
                                                                        v-if="task.name === 'approve_additional_budget'"
                                                                        ></approve-budget-task>
                                                            </td>
                                                            <td>
                                                                <span><i @click="deleteDoneTask(task.id)"
                                                                         style="cursor: pointer"
                                                                         class="fa fa-trash"></i></span>
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import ApproveBudgetTask from './misc/tasks/ApproveBudgetTask'

  export default {
    name: 'Tasks',
    components: {
      ApproveBudgetTask
    },
    data () {
      return {
        tasks: [],
        done_tasks: [],
        newTab: true
      }
    },
    created () {
      this.getNotifications('False')
    },
    methods: {
      getNotifications (done) {
        /** Get list of tasks, done or not done */
        this.getList(this.apiPrefix, this.tasksApiUrl + `?done=${done}&for_user_id=${this.$store.getters.getAuth['userId']}`)
          .then(resp => {

            if (done === 'False') {
              this.newTab = true
              this.tasks = resp.data
              this.done_tasks = []
            } else {
              this.newTab = false
              this.done_tasks = resp.data
              this.tasks = []
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      handleTaskUpdated (data) {
        /** Handle taskUpdated event */
        this.tasks = this.tasks.filter(task => task.id !== data.id)
      },
      deleteDoneTask (taskId) {
        /** Delete task that is marked done */
        this.delete(this.apiPrefix, this.tasksApiUrl, taskId)
          .then(() => {
            this.done_tasks = this.done_tasks.filter(task => task.id !== taskId)
          })
          .catch(err => {
            console.log(err.response)
          })
      }
    }
  }
</script>

<style scoped>
    table tr {
        line-height: 25px;
        min-height: 25px;
        height: 25px;
    }

    .tasks-td {
        padding: 1px;
        font-size: 0.9em;
        vertical-align: middle;
        text-align: center;
    }
</style>